<template>
  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
    scrim="#0a192f"
    :opacity="0.7"
  >
    <div class="loading-container">
      <div class="spinner-box">
        <div class="pulse-container">
          <div class="pulse-bubble pulse-bubble-1"></div>
          <div class="pulse-bubble pulse-bubble-2"></div>
          <div class="pulse-bubble pulse-bubble-3"></div>
        </div>
      </div>
      <div class="loading-text">Loading...</div>
    </div>
  </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OverlayLoading",
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-text {
  margin-top: 20px;
  color: #00d2ff;
  font-family: "Outfit", sans-serif;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 0.9rem;
  animation: fadeInOut 1.5s ease-in-out infinite;
}

.spinner-box {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.pulse-container {
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #00d2ff;
}

.pulse-bubble-1 {
  animation: pulse 0.4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
  animation: pulse 0.4s ease 0.2s infinite alternate;
}
.pulse-bubble-3 {
  animation: pulse 0.4s ease 0.4s infinite alternate;
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.25;
    transform: scale(0.75);
  }
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

:deep(.v-overlay__scrim) {
  backdrop-filter: blur(8px);
}
</style>
